import { $Q, $Qll } from "graditify-utils"

function focusDropDownItem() {
  const items = $Qll('.nav__child');
  const elementsDropdown = $Qll('*');

  elementsDropdown.forEach((item) => {
    item.addEventListener('focus', () => {
      const { activeElement } = document;
      const closestDropdown = activeElement.closest('.nav__child');
      const isDropdown = activeElement.classList.contains('nav__child');

      if (isDropdown || !closestDropdown) {
        items.forEach((item) => item.setAttribute('data-active', 'false'))
      }
    })
  })

  document.addEventListener('keydown', (event) => {
    const { activeElement } = document;
    const isDropdown = activeElement.classList.contains('nav__child');

    if (event.code === "ArrowDown" && isDropdown) {
      event.preventDefault();
      activeElement.setAttribute('data-active', 'true');

      const dropdown = $Q('.dropdown', activeElement);
      const firstLi = $Q('li:first-of-type a', dropdown);
      firstLi.focus();
    }
  });
}

export { focusDropDownItem }
